<script setup>
import { defineEmits } from 'vue'
const props = defineProps({
    modelValue: String,
    placeholder: String,
    readonly: Boolean,
})

const emit = defineEmits('update:modelValue')

</script>

<template>
    <span v-if="props.modelValue" class="w-fit outline-none" @input="$emit('update:modelValue', $event.target.innerText)" :contenteditable="!props.readonly" v-bind="$attrs">
       {{props.modelValue || props.placeholder}}
    </span>
</template>

<style scoped>
[contenteditable=true]:empty:before{
    content: attr(dh-ph);
  }
</style>